(ns ui.view.nev.view
  (:require
   [ui.icons :as icons]
   [clojure.set :as set]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entity-types :as entity-types]
   [frontend.actions.account :as account-actions]
   [frontend.actions.common :as common-actions]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.modals.entity-audit-trail.view :as audit-trail-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.oppo.events :as oppo-events]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.skeleton.view :as skeleton]
   [ui.components.toggle.view :as toggle]
   [ui.dom-globals :as dg]
   [ui.editors.nev-view-editor.view :as nev-view-editor]

   ;; TODO: remove after implemented in ui.- namespace
   [ui.state.session.sub :as session-sub]
   [ui.util :as uu]
   [ui.view.card.view :as card-view]
   [ui.view.nev.entity-specific-actions :as entity-specific-actions]
   [ui.view.nev.event :as event]
   [ui.view.nev.model :as nev-model]
   [ui.view.nev.sidebar :as sidebar]
   [ui.view.nev.sub :as sub]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.view.nev.view-selector :as view-selector]))

;; TODO: This needs to be revised now that cards are responsible for data fetching on mount
;; When exatcly should cards remount
(defn card-element-key
  "Key for each card so if this combination changes, card re-mounts"
  [{:keys [view-entity viewed-entity-id card-id card-index remount-counter]}]
  (let [view-id (:db/id view-entity)
        view-updated-on (:common/updated-on view-entity)]
    (->> ["view"
          view-id
          "updated"
          view-updated-on
          "viewed-entity"
          viewed-entity-id
          "card"
          card-id
          "index"
          card-index
          "-"
          remount-counter]
         (string/join "-"))))

(defn switch-action-item
  [{:keys [label icon-class checked? on-change]}]
  {:custom-item? true
   :custom-class "text-base leading-none text-gray-700 rounded flex items-center h-[30px] px-[5px] relative pl-[30px] pr-[15px] select-none outline-none"
   :value        [:div
                  {:class    "relative flex items-center justify-between gap-2"
                   :on-click (fn [e]
                               (oops/ocall e "stopPropagation")
                               (oops/ocall e "preventDefault"))}
                  [:div
                   {:class "flex items-center gap-2"}
                   [:i {:class (uu/cm icon-class "text-sm m-0")}]
                   [:span label]]
                  [:div
                   {:on-click dg/stop-propagation}
                   [toggle/toggle
                    {:checked?  checked?
                     :on-change on-change}]]]})

(defn deal-action-items
  [{:keys [entity]}]
  (let [entity-id (:db/id entity)
        status (:oppo/status entity)

        pass-item {:label      (loc/tr :pass)
                   :icon-class "fal fa-ban"
                   :on-click   #(oppo-events/start-pass! entity)}

        put-on-hold-item {:label      (loc/tr :put-on-hold)
                          :icon-class "fal fa-pause"
                          :on-click   #(oppo-events/start-put-on-hold! entity)}

        portfolio-item {:label      (loc/tr :portfolio)
                        :icon-class "fal fa-check"
                        :on-click   #(oppo-events/start-to-portfolio! entity)}

        activate-item {:label      (loc/tr :activate)
                       :icon-class "fal fa-redo-alt"
                       :on-click   #(oppo-events/resurrect! entity-id)}

        items (case status
                :oppo.status/ok
                [pass-item
                 put-on-hold-item
                 portfolio-item]

                :oppo.status/on-hold
                [activate-item
                 pass-item
                 portfolio-item]

                :oppo.status/passed
                [activate-item
                 put-on-hold-item
                 portfolio-item]

                :oppo.status/portfolio
                [activate-item
                 put-on-hold-item
                 pass-item]
                nil)]
    (when items
      (conj items {:separator? true}))))

(defn actions-dropdown-items
  [ctx {:keys [can-edit-view? system-default-view?
               edit-disabled? view-owner-label
               favorite-view? selected-entity
               flagged?
               can-configure-views?
               can-switch-to-classic-mode?]}]
  (concat
   []
   (when can-switch-to-classic-mode?
     [(switch-action-item
       {:label      (loc/tr :classic-mode)
        :icon-class "fal fa-eye"
        :checked?   false
        :on-change  (fn [checked?]
                      (account-actions/update-preferences
                       {:classic-entity-viewer-enabled? checked?}))})
      {:separator? true}])

   (when (and @(r/track session/entity-graph?)
              (contains? entity-types/graph-for-entity-types
                         (:entity/type selected-entity)))
     [{:label (loc/tr :entity-graph)
       :icon-class "fa fa-diagram-project"
       :on-click (fn [_]
                   (routing/set-view! [:entity-graph :id
                                       (:db/id selected-entity)]))}])

   (when (= (:entity/type selected-entity) :entity.type/oppo)
     (deal-action-items
      {:entity selected-entity}))

   [(-> (zap-toolbar/delete-button
         selected-entity
         nil
         (fn []
           (rf/dispatch [::event/delete-selected-entity-success ctx])))
        (merge
         {:icon-class "fal fa-trash"})
        (set/rename-keys {:on-select :on-click})
        (assoc :label (loc/tr :delete)))


    {:label      (loc/tr (if flagged?
                           :unflag-entity-menu-item
                           :flag-entity-menu-item))
     :icon-class "fal fa-star"
     :on-click   #(common-actions/toggle-flag selected-entity flagged?)}

    {:label      (loc/tr :audit-trail)
     :icon-class "fal fa-history"
     :on-click   (fn []
                   (let [primary-entity-id (:db/id selected-entity)
                         entity-ids [primary-entity-id]                                             ;; TODO: Add other entities?
                         entity-name (entity/display-string selected-entity :short session/get-entity)
                         modal-title (loc/tr :audit-trail-for-entity [entity-name])]
                     (modals/open-modal!
                      audit-trail-modal/modal-key
                      {:title               modal-title
                       :entity-ids          entity-ids
                       :primary-entity-type (:entity/type selected-entity)
                       :primary-entity-id   primary-entity-id})))}]

   (when can-configure-views?
     [{:separator? true}
      (switch-action-item
       {:label      (loc/tr :my-favorite-view)
        :checked?   favorite-view?
        :on-change  #(rf/dispatch [::event/toggle-favorite-view ctx])
        :icon-class "fal fa-star"})
      {:icon-class "fal fa-cog"
       :label      (loc/tr :view-editor/view-settings)
       :on-click   #(rf/dispatch [::event/open-view-editor ctx {:update-view? true}])
       :tooltip    (when edit-disabled?
                     (if system-default-view?
                       (loc/tr :view-editor/system-level-view-cannot-be-edited)
                       [:div
                        {:class "flex flex-col"}
                        [:span
                         (loc/tr :view-editor/no-edit-permissions-tooltip-beginning)]
                        [:ul
                         {:class "list-decimal pl-4"}
                         [:li (loc/tr :view-editor/clone-and-make-changes-or)]
                         [:li (loc/tr :view-editor/request-view-owner-to-make-changes [view-owner-label])]]]))
       :disabled?  (not can-edit-view?)}

      {:icon-class "fal fa-clone"
       :label      (loc/tr :view-editor/clone-view)
       :on-click   #(rf/dispatch [::event/open-view-editor ctx {:clone-view? true}])}

      {:icon-class "fal fa-plus"
       :label      (loc/tr :view-editor/create-new-view)
       :on-click   #(rf/dispatch [::event/open-view-editor ctx {:create-new-view? true}])}])))

(defn view-actions-dropdown
  [{:keys [ctx]}]
  (let [can-edit-view? @(rf/subscribe [::sub/can-edit-view? ctx])
        system-default-view? @(rf/subscribe [::sub/system-default-view? ctx])
        edit-disabled? (or system-default-view? (not can-edit-view?))
        view-owner-label @(rf/subscribe [::sub/view-owner-label ctx])
        favorite-view? @(rf/subscribe [::sub/favorite-view? ctx])
        selected-entity @(rf/subscribe [::sub/selected-entity ctx])
        flagged? @(rf/subscribe [::sub/selected-entity-flagged? ctx])
        can-configure-views? @(rf/subscribe [::sub/can-configure-views-for-selected-entity-type? ctx])
        can-switch-to-classic-mode? @(rf/subscribe [::sub/can-switch-to-classic-mode? ctx])]
    [:<>
     [dropdown-menu/view
      {:items (actions-dropdown-items
               ctx
               {:flagged?             flagged?
                :can-edit-view?       can-edit-view?
                :system-default-view? system-default-view?
                :edit-disabled?       edit-disabled?
                :view-owner-label     view-owner-label
                :favorite-view?       favorite-view?
                :selected-entity      selected-entity
                :can-configure-views? can-configure-views?
                :can-switch-to-classic-mode? can-switch-to-classic-mode?})

       :props {:hide-arrow? true
               :align       :end}
       :trigger-as-child
       [:span
        [:button
         {:class "w-8 h-8 flex justify-center items-center rounded hover:bg-base-regular hover:text-base-light-text-paler"}
         [:i.fal.fa-ellipsis-v
          {:class "text-2xl"}]]]}]]))

(defn page-header-left
  [{:keys [ctx]}]
  (let [entity-label @(rf/subscribe [::sub/entity-label ctx])
        entity-icon-class @(rf/subscribe [::sub/entity-icon-class ctx])
        entity-type-label @(rf/subscribe [::sub/entity-type-label ctx])
        loading-entity? @(rf/subscribe [::sub/entity-loading? ctx])
        sidebar-mode @(rf/subscribe [::sub/sidebar-mode ctx])
        sidebar-expanded? (= sidebar-mode :expanded)]

    [:div
     {:class "flex gap-5 items-strech"}
     [tooltip/view
      {:side :left}
      [:span
       {:class "rounded p-2 hover:bg-complement-light"
        :on-click #(rf/dispatch [::event/set-sidebar-mode ctx (if sidebar-expanded? :collapsed :expanded)])}
       [icons/panel-left-icon
        {:class "h-5 w-5"}]]
      [:span (loc/tr (if sidebar-expanded? :collapse-sidebar :expand-sidebar))]]
     [:div
      {:class "w-px bg-base-gloomy"}]
     [:div
      {:class "flex items-center gap-3"}
      [:div
       {:class "w-10 h-10 flex justify-center items-center rounded bg-complement-light"}
       [:i {:class (uu/cm "text-2xl" entity-icon-class)}]]
      [:div
       (if loading-entity?
         [:div
          {:class "space-y-2"}
          [skeleton/view {:class "h-2 w-20"}]
          [skeleton/view {:class "h-4 w-32"}]]
         [:div
          [:p
           {:class "text-xs m-0 leading-none text-base-light-text-paler"}
           entity-type-label]
          [:p
           {:class "text-lg font-bold"}
           entity-label]])]]]))

(defn page-header-right
  [{:keys [ctx] :as props}]
  (let [selected-view-option @(rf/subscribe [::sub/view-option ctx])
        primary-entity-id @(rf/subscribe [::sub/primary-entity-id ctx])
        can-configure-views? @(rf/subscribe [::sub/can-configure-views-for-selected-entity-type? ctx])]
    [:div
     {:class "flex items-center gap-3"}
     (when can-configure-views?
       [view-selector/view
        {:ctx ctx
         :select-view (fn [view-id]
                        (when-not (= view-id (:value selected-view-option))
                          (rf/dispatch [::event/open-view (assoc ctx :view-id view-id
                                                                 :entity-id primary-entity-id)])

                          (when-let [view-change-callback-fn (:view-change-callback-fn props)]
                            (view-change-callback-fn {:view-id   view-id
                                                      :entity-id primary-entity-id}))))}])]))

(defn page-header
  [{:keys [preview-mode? ctx] :as props}]
  (let [selected-entity-type @(rf/subscribe [::sub/selected-entity-type ctx])]
    [:div
     {:class "py-3 flex items-center justify-between"}
     [page-header-left props]
     (when-not preview-mode?
       [:div
        {:class "flex justify-between gap-3 items-center"}
        [page-header-right props]
        [entity-specific-actions/view
         (assoc props :entity-type selected-entity-type)]
        [view-actions-dropdown props]])]))

(defn cards-list
  [{:keys [cards entity-id view-entity
           entity-type entity-icon entity-label ctx]}]
  (let [card-count (count cards)
        remount-counter @(rf/subscribe [::sub/card-remount-counter ctx])]
    [:<>
     (->> cards
          (map-indexed
           (fn [card-index card]
             (let [card-id (:db/id card)
                   element-id (str card-id "-" card-index)]
               ^{:key (card-element-key {:view-entity      view-entity
                                         :viewed-entity-id entity-id
                                         :card-id          card-id
                                         :card-index       card-index
                                         :remount-counter remount-counter})}
               [:div
                {:id    element-id
                 :class "w-full"}
                [card-view/view-with-data-fetching
                 {:card                                    card
                  :entity-id                               entity-id
                  :entity-type                             entity-type
                  :card-state-path                         (nev-model/card-state-full-path (:state-path ctx) entity-id card-id)
                  :entity-icon                             entity-icon
                  :entity-label                            entity-label
                  :prevent-clear-state-on-unmount?         true
                  :prevent-close-subscriptions-on-unmount? false
                  :navigation-between-cards-enabled?       true
                  :subscribe-to-realtime-changes?          true
                  :can-navigate-to-previous-card?          (< 0 card-index)
                  :can-navigate-to-next-card?              (< card-index (dec card-count))
                  :on-navigate-to-previous-card            #(rf/dispatch-sync [::event/navigate-to-new-full-screen-card ctx :previous])
                  :on-navigate-to-next-card                #(rf/dispatch-sync [::event/navigate-to-new-full-screen-card ctx :next])}]]))))]))

(defn page-content
  [{:keys [ctx] :as props}]
  (let [entity-id @(rf/subscribe [::sub/selected-entity-id ctx])
        view-entity @(rf/subscribe [::sub/cached-view ctx])
        sorted-cards @(rf/subscribe [::sub/selected-section-cards ctx])
        view-entity-type @(rf/subscribe [::sub/view-entity-type ctx])
        entity-label @(rf/subscribe [::sub/entity-label ctx])
        entity-icon @(rf/subscribe [::sub/entity-icon-class ctx])]
    [cards-list
     (merge
      props
      {:cards        sorted-cards
       :view-entity  view-entity
       :entity-id    entity-id
       :entity-type  view-entity-type
       :entity-label entity-label
       :entity-icon  entity-icon})]))

(defn page
  [{:keys [ctx] :as props}]
  (let [view-id @(rf/subscribe [::sub/view-id ctx])
        props (assoc props :view-id view-id)
        selected-section @(rf/subscribe [::sub/selected-section ctx])
        sidebar-mode @(rf/subscribe [::sub/sidebar-mode ctx])
        sidebar-expanded? (= sidebar-mode :expanded)]
    [:div
     {:class "h-full w-full flex flex-col overflow-hidden bg-complement-light"}
     [:div
      {:class "relative h-full flex flex-col max-h-full grow overflow-hidden"}
      [:div
       {:class "px-5 bg-base-light flex justify-start gap-3 border-b border-solid border-base-light-border-paler"}
       [:div
        {:class "grow shrink-0"}
        [page-header props]]]

      ^{:key (str "page-container- " selected-section)}
      [:div
       {:class "flex transition-all duration-300 overflow-hidden h-[calc(100vh-53px-65px)] relative"}
       [:div
        {:class (uu/cm "absolute top-0 left-0 h-full transition-transform duration-300 ease-in-out w-80 bg-complement-light"
                       (if sidebar-expanded?
                         "translate-x-0"
                         "-translate-x-full"))}
        [sidebar/view props]]

       [:div
        {:class (uu/cm "flex flex-1 grow h-full overflow-hidden overflow-y-auto transition-all duration-300 ease-in-out"
                       (if sidebar-expanded?
                         "ml-80"
                         "ml-0"))}
        [:div
         {:class "h-full grow overflow-auto"}
         [:div
          {:class "lg:container flex gap-4 p-4 flex-col items-start mx-auto"}
          [page-content props]]]]]]]))

;; for inspecting frontend db state
(defn test-view
  []
  (let [views @(rf/subscribe [::session-sub/entities-for-type :entity.type/view])
        not-default-views (->> views
                               (remove (fn [{:keys [db/id]}]
                                         (string? id))))
        cards @(rf/subscribe [::session-sub/entities-for-type :entity.type/card])
        cards-not-default (->> cards
                               (remove (fn [{:keys [db/id]}]
                                         (string? id))))
        display-strs (fn [id-or-ids]
                       (let [ids (if (coll? id-or-ids) id-or-ids [id-or-ids])]
                         (->> ids
                              (map session/get-entity)
                              (map entity/display-string)
                              (string/join ", "))))]
    [:div
     [:div
      {:class "flex gap-5"}
      [:div (str "All views " (count views))]
      [:div (str "Views not default " (count not-default-views))]
      [:div (str "All cards " (count cards))]
      [:div (str "Cards not default " (count cards-not-default))]]
     [:div
      {:class "flex gap-2"}
      (->> cards-not-default
           (map (fn [card]
                  (let [title (:card/title card)
                        owner (->> card
                                   :common/owner
                                   (display-strs))
                        access-level (:card/access-level card)
                        read (->> card
                                  :card/read-access
                                  (display-strs))
                        write (->> card
                                   :card/write-access
                                   (display-strs))
                        share (->> card
                                   :card/share-access
                                   (display-strs))]
                    ^{:keys (str (:db/id card))}
                    [:div
                     {:class "border"}
                     [:p title]
                     [:p "Access lvl " access-level]
                     [:p "Owner: " owner]
                     [:p "Read " read]
                     [:p "Write " write]
                     [:p "Share " share]])))
           (doall))]]))

(defn component
  [{:keys [ctx] :as props}]
  (let [initialized? @(rf/subscribe [::sub/initialized? ctx])]
    (when initialized?
      [:<>
       #_[test-view]
       [page props]
       [nev-view-editor/view
        ;; FIXME: Unfortunate hack to avoid circular dependency
        {:render-preview
         (fn [props]
           (let [ctx (select-keys props [:state-path])
                 props (assoc props :ctx ctx)]
             [page props]))}]])))

(defn view
  [{:keys [entity-id entity-type state-path] :as props}]
  (let [ctx {:entity-id   entity-id
             :entity-type entity-type
             :state-path  state-path}
        props (assoc props :ctx ctx)]
    [component props]))

(defn view-with-data-fetching
  [{:keys [state-path entity-id entity-type] :as _props}]
  (let [abort-controller (dg/abort-controller)
        signal (oops/oget abort-controller "signal")
        ctx {:entity-id                      entity-id
             :entity-type                    entity-type
             :state-path                     state-path
             :signal                         signal
             :subscribe-to-realtime-changes? true}
        cleanup-fn (fn []
                     (rf/dispatch [::event/cleanup (dissoc ctx :signal)]))]
    (oops/ocall signal "addEventListener" "abort" cleanup-fn)
    (r/create-class
     {:component-did-mount    (fn []
                                (rf/dispatch [::event/open-default-view ctx]))
      :component-will-unmount (fn []
                                (oops/ocall abort-controller "abort"))
      :reagent-render
      (fn [props]
        (let [props (assoc props :ctx ctx)]
          [component props]))})))
